export const PATHS = {
	HOME: '/',
	AUTH: '/auth',

	callbacks: {
		AUTH: '/auth/callback',
		// URL string stays the old value on purpose — it's registered in Palary's partner redirectURL
		// allowlist; only the constant name and file location were unified, not the actual path.
		CONSENT: '/debitcards/consent/callback',
	},

	user: {
		PROFILE: 'user-profile',
		YOURDEBITCARD: 'user-card',
		TRANSACTIONS: 'user-transactions',
	},

	company: {
		COMPANY_PROFILE: 'company-profile',
		EMPLOYEES: 'employees',
		DEBITCARDS: 'debit-cards',
		BENEFITS: 'benefits',
		TOPUPPORDERS: 'topuporders',
		TOPUPS: 'topups',
	},
};
